/**
 * Megamenu Class
 */
class Megamenu {

	/**
	 * Constructor
	 *
	 * @param {node} block
	 * @return {void}
	 */
	constructor( block ) {

		this.block = block;

		if ( !this.block ) {

			return false;

		}

		// Before Ukrain fix this.breakpoint = 1240; //859;//1110; //1025;//768;
		this.breakpoint = 1285; //859;//1110; //1025;//768;

		// this.breakpointSmallMobile = 639;
		this.breakpointSmallMobile = 756;

		this.body = document.body;
		this.megamenuWrapper = this.block.querySelector( ".b-megamenu__wrapper" );
		this.hamburgerMenu = this.block.querySelector( ".navigation__checkbox" );
		this.menuItems = this.block.querySelectorAll( ".is-dropdown" );
		this.menuItemsAll = this.block.querySelectorAll( ".b-megamenu-item" );

		this.menuItemsAllMenuname = this.block.querySelectorAll(
			".b-megamenu-item .b-megamenu-item__menuname",
		);

		this.megamenuExtras = this.block.querySelector( ".b-megamenu-extras" );

		if ( this.hasExtras() ) {

			this.buttons =
				this.megamenuExtras.querySelector( ".wp-block-buttons" );
			this.megamenuExtrasItems =
				this.megamenuExtras.querySelectorAll( ".megamenu-extras" );

		}

		this.mediaQuery = window.matchMedia( `(min-width:${this.breakpoint}px)` );
		this.mediaQuerySmallMobile = window.matchMedia(
			`(max-width:${this.breakpointSmallMobile}px)`,
		);
		this.mediaQueryBetween = window.matchMedia(
			`(min-width:${this.breakpointSmallMobile + 1}px) and (max-width:${this.breakpoint - 1}px)`,
		);

		this.addEvents();
		this.getExtrasHeightOnLoad = this.getExtrasHeight();

		this.header = document.querySelector( "header" );
		this.blockInsideHeader = "";
		if ( this.header ) {

			this.blockInsideHeader = this.header.querySelector( ".b-megamenu" );

		}

		this.searchContainer = block.querySelector( ".js-search-container" );
		this.parentSearchToggle = block.querySelector(
			".b-megamenu-search__toggle",
		);

	}

	/**
	 * Has alignfull
	 *
	 * @param {element} el
	 * @return {bool}
	 */
	hasAlignFull( el ) {

		return el.classList.contains( "alignfull" ) ? true : false;

	}

	/**
	 * Set smooth body scroll
	 *
	 * @param {bool} bool
	 * @return {void}
	 */
	setBodySmoothScroll( bool ) {

		if ( bool ) {

			setTimeout( () => {

				document.documentElement.style.scrollBehavior = "smooth";

			}, 100 );

		} else {

			document.documentElement.style.scrollBehavior = "unset";

		}

	}

	/**
	 * Stop body scroll when mobile menu is open
	 *
	 * @param {bool} bool
	 * @return {void}
	 */
	letBodyScroll( bool ) {

		if ( bool ) {

			const scrollY = this.body.style.top;
			setTimeout( () => {

				this.body.style.position = "";
				window.scrollTo( 0, parseInt( scrollY + 90 || "0" ) * -1 );
				this.body.style.top = "";

			}, 60 );
			// this.setBodySmoothScroll( true );

		} else {

			// this.setBodySmoothScroll( false );
			const scrollY =
				document.documentElement.style.getPropertyValue( "--scroll-y" );
			this.body.style.position = "fixed";
			this.body.style.top = `-${scrollY}`;

		}

	}

	/**
	 * Check if Megamenu Block has Megamenu Extras block
	 *
	 * @return {bool}
	 */
	hasExtras() {

		return this.megamenuExtras ? true : false;

	}

	/**
	 * Has buttons block inside the Megamenu Extras block
	 *
	 * @return {bool}
	 */
	hasMegamenuButtons() {

		return this.buttons ? true : false;

	}

	/**
	 * Get Extras Width
	 *
	 * @return {void}
	 */
	getExtrasWidth() {

		if ( this.hasExtras() ) {

			return this.megamenuExtras.offsetWidth;

		}

	}

	/**
	 * Get Extras Block Height
	 *
	 * @return {void}
	 */
	getExtrasHeight() {

		if ( this.hasExtras() ) {

			return this.megamenuExtras.offsetHeight;

		}

	}

	/**
	 * Get Buttons Width
	 *
	 * @return {void}
	 */
	getButtonsWidth() {

		if ( this.hasMegamenuButtons() ) {

			return this.buttons.offsetWidth;

		}

	}

	/**
	 * Get Buttons Height
	 *
	 * @return {void}
	 */
	getButtonsHeight() {

		if ( this.hasMegamenuButtons() ) {

			return this.buttons.offsetHeight;

		}

	}

	/**
	 * Reload page if comming from back button
	 *
	 * @return {void}
	 */
	reloadPageIfCommingFromBackButton() {

		const perfEntries = performance.getEntriesByType( "navigation" );
		if ( perfEntries[0].type === "back_forward" ) {

			location.reload();

		}

	}

	/**
	 * Add Class to element
	 *
	 * @param  {element} el
	 * @param  {string} className
	 * @return {void}
	 */
	addClassToEl( el, className ) {

		if ( !el.classList.contains( className ) ) {

			el.classList.add( className );

		}

	}

	/**
	 * Remove Class from element
	 *
	 * @param  {element} el
	 * @param  {string} classToRemove
	 * @return {void}
	 */
	removeClassFromEl( el, classToRemove ) {

		if ( el.classList.contains( classToRemove ) ) {

			el.classList.remove( classToRemove );

		}

	}

	/**
	 * Check if element has class
	 *
	 * @param {element} el
	 * @param {string} classToCheck
	 * @return {boolean}
	 */
	hasClass = ( el, classToCheck ) => {

		return el.classList.contains( classToCheck );

	};

	/**
	 * Remove Class from all elements
	 *
	 * @param {element} elements
	 * @param {string}  classToRemove
	 */
	removeClassFromAll = ( elements, classToRemove ) => {

		elements.forEach( ( el ) => {

			if ( this.hasClass( el, classToRemove ) ) {

				el.classList.remove( classToRemove );

			}

		} );

	};

	/**
	 * Add Class to all elements
	 *
	 * @param {element} elements
	 * @param {string}  classToAdd
	 */
	addClassToAll = ( elements, classToAdd ) => {

		elements.forEach( ( el ) => {

			this.addClassToEl( el, classToAdd );

		} );

	};

	/**
	 * onClickOutside
	 *
	 * @param {object} e Event
	 * @return {void}
	 */
	onClickOutside = ( e ) => {

		this.resetFocus();
		this.openedMenuItem =
			this.megamenuWrapper.querySelector( ".is-dropdown--open" );
		this.openedColumnWrapper = this.megamenuWrapper.querySelector(
			".is-dropdown--open .b-megamenu-item__columns-wrapper",
		);

		const withinBoundaries = e
			.composedPath()
			.includes( this.openedColumnWrapper, this.openedMenuItem );

		if ( withinBoundaries ) {
		} else {

			this.deactivateMegamenu();

		}

	};

	/**
	 * closeMegamenu - reset point
	 *
	 * @return {void}
	 */
	closeMegamenuResetPoint() {

		this.addClassToEl( this.block, "js-megamenu--close" );
		this.removeClassFromEl( this.block, "js-megamenu--open" );

	}

	/**
	 * Open megamenu for clicked element
	 *
	 * @param {element} el
	 * @return {void}
	 */
	openMegamenu( el ) {

		this.removeClassFromEl( el, "js-megamenu--close" );
		this.addClassToEl( el, "js-megamenu--open" );

	}

	/**
	 * closeDropdown - reset point
	 *
	 * @return {void}
	 */
	closeAllDropdownResetPoint() {

		this.removeClassFromAll( this.menuItems, "is-dropdown--open" );
		this.addClassToAll( this.menuItems, "is-dropdown--close" );

	}

	/**
	 * openDropdown for clicked element
	 *
	 * @param {element} el
	 * @return {void}
	 */
	openDropdown( el ) {

		if ( this.hasClass( el, "is-dropdown" ) ) {

			this.addClassToEl( el, "is-dropdown--open" );
			this.removeClassFromEl( el, "is-dropdown--close" );
			this.backArrowEl.addEventListener(
				"click",
				this.clickeBackArrowdHandler,
			);

		}

	}

	/**
	 * Hide menu items with dropdown except clicked element
	 *
	 * @param {element} el clicked element
	 * @return {void}
	 */
	hideMenuItemsWithDropdown( el ) {

		if ( this.hasExtras() ) {

			this.addClassToAll( this.megamenuExtrasItems, "js-menuitem--hidden" );
			this.addClassToEl( this.buttons, "js-menuitem--hidden" );

		}
		this.addClassToEl( this.block, "js-dropdown--opened" );
		this.addClassToAll( this.menuItemsAll, "js-menuitem--hidden" );
		this.removeClassFromEl( el, "js-menuitem--hidden" );

	}

	/**
	 * Unhide menu items with dropdown
	 *
	 * @return {void}
	 */
	unHideMenuItemsWithDropdown() {

		setTimeout( () => {

			this.removeClassFromEl( this.block, "js-dropdown--opened" );
			this.removeClassFromAll( this.menuItemsAll, "js-menuitem--hidden" );
			if ( this.hasExtras() ) {

				this.removeClassFromAll(
					this.megamenuExtrasItems,
					"js-menuitem--hidden",
				);
				this.removeClassFromEl( this.buttons, "js-menuitem--hidden" );

			}

		}, 50 );

	}

	/**
	 * toggleMegamenu - reset point
	 *
	 * @return {void}
	 */
	toggleMegamenu() {

		this.block.classList.toggle( "js-megamenu--close" );
		this.block.classList.toggle( "js-megamenu--open" );

		if ( this.block.classList.contains( "js-megamenu--close" ) ) {

			this.closeHamburger();

		}

	}

	/**
	 * toggleHamburger on element
	 *
	 * @param {element} el
	 * @return {void}
	 */
	toggleHamburger( el ) {

		this.closeSearchBar();
		el.classList.toggle( "js-hamburger-clicked" );
		setTimeout( () => {

			el.classList.toggle( "js-hamburger-opened" );
			this.letBodyScroll( false );

		}, 50 );

	}

	/**
	 * closeHamburger
	 *
	 * @return {void}
	 */
	closeHamburger() {

		setTimeout( () => {

			this.removeClassFromEl( this.block, "js-hamburger-opened" );

		}, 60 );
		this.letBodyScroll( true );
		this.removeClassFromEl( this.block, "js-hamburger-clicked" );
		this.removeClassFromEl( this.hamburgerMenu, "js-hamburger-clicked" );

		this.removeClassFromEl( this.block, "js-wpml-dropdown-shown" );

		if ( this.block.querySelector( ".js-cloned-wpml-dropdown" ) ) {

			this.block.querySelector( ".js-cloned-wpml-dropdown" ).style.top = "";

		}

		this.closeMegamenuResetPoint();
		this.closeAllDropdownResetPoint();
		this.hamburgerMenu.checked = false;
		this.unHideMenuItemsWithDropdown();

	}

	/**
	 * activateMobileMegamenu
	 *
	 * @return {void}
	 */
	activateMobileMegamenu() {

		this.closeMegamenuResetPoint();

	}

	/**
	 * deactivateMegamenu to the reset point
	 *
	 * @return {void}
	 */
	deactivateMegamenu() {

		this.closeMegamenuResetPoint();
		this.closeAllDropdownResetPoint();

		window.removeEventListener( "pointerout", this.onClickOutside );

	}

	/**
	 * clickeBackArrowdHandler
	 */
	clickeBackArrowdHandler = () => {

		this.backArrowEl.removeEventListener(
			"click",
			this.clickeBackArrowdHandler,
		);

		setTimeout( () => {

			this.closeAllDropdownResetPoint();

		}, 50 );
		this.unHideMenuItemsWithDropdown();

	};

	/**
	 * closeSearchBar
	 *
	 * @return {void}
	 */
	closeSearchBar() {

		if ( this.searchContainer && this.parentSearchToggle ) {

			this.removeClassFromEl( this.searchContainer, "is-active" );
			this.removeClassFromEl(
				this.parentSearchToggle,
				"is-dropdown--open",
			);
			this.searchContainer.classList.remove(
				"js-header-searchbar--opened",
			);

		}

	}

	/**
	 * Dispaly or hide target element by click on the trigger
	 *
	 * @param {element} target Content element that will be shown or hidden
	 * @param {element} trigger Clickable element that will trigger show/hide action
	 * @return {void}
	 */
	toggleDisplay( target, trigger ) {

		if ( !target || !trigger ) {

			return;

		}

		/**
		 * clickedHandler
		 *
		 * @param {object} e
		 */
		const clickedHandler = ( e ) => {

			this.backArrowEl = trigger.querySelector(
				".b-megamenu-item__menuname",
			);

			this.closeSearchBar();

			if ( e.type === "keyup" ) {

				this.focusHandler( e );

			}

			if ( this.hasClass( target, "js-megamenu--open" ) ) {

				if (
					this.hasClass( trigger, "is-dropdown" ) &&
					this.hasClass( trigger, "is-dropdown--open" )
				) {

					return;

				}

				this.columnsWrapper = trigger.querySelector(
					".b-megamenu-item__columns-wrapper",
				);

				if ( this.hasClass( this.block, "js-wpml-dropdown-shown" ) ) {

					this.removeClassFromEl(
						this.block,
						"js-wpml-dropdown-shown",
					);

					if ( this.block.querySelector( ".js-cloned-wpml-dropdown" ) ) {

						this.block.querySelector(
							".js-cloned-wpml-dropdown",
						).style.top = "";

					}

				}

				this.closeAllDropdownResetPoint();
				if ( this.hasClass( trigger, "is-dropdown" ) ) {

					setTimeout( () => {

						this.openDropdown( trigger );
						if ( this.hasClass( this.block, "js-megamenu--mobile" ) ) {

							this.hideMenuItemsWithDropdown( trigger );

						}

					}, 50 );

				}

			} else if ( this.hasClass( target, "js-megamenu--close" ) ) {

				if ( this.hasClass( trigger, "is-dropdown" ) ) {

					this.openDropdown( trigger );
					this.openMegamenu( target );

				}

			}
			if ( !this.hasClass( this.block, "js-megamenu--mobile" ) ) {

				window.addEventListener( "pointerout", this.onClickOutside );

			}

		};

		/**
		 * handleMediaQueryChange
		 *
		 * @param {object} e
		 */
		const handleMediaQueryChange = ( e ) => {

			if ( e.matches ) {

				//if desktop

				trigger.addEventListener( "pointerover", clickedHandler );
				trigger.addEventListener( "keyup", clickedHandler );

				trigger.addEventListener( "focusout", () => {

					this.resetFocus();

				} );

				trigger.removeEventListener( "click", clickedHandler );

			} else {

				//if mobile

				trigger.addEventListener( "click", clickedHandler );
				trigger.removeEventListener( "keyup", clickedHandler );
				trigger.removeEventListener( "pointerover", clickedHandler );

			}

		};

		// Register event listener
		this.mediaQuery.addEventListener( "change", handleMediaQueryChange );

		// Initial check
		handleMediaQueryChange( this.mediaQuery );

	}

	/**
	 * hamburgerClickedHandler
	 *
	 * @param {object} e
	 */
	hamburgerClickedHandler = ( e ) => {

		this.toggleHamburger( e.target );
		this.toggleHamburger( this.block );

		this.toggleMegamenu();

		if (
			this.hasClass( this.block, "js-hamburger-opened" ) &&
			this.hasClass( this.block, "js-megamenu--close" )
		) {

			this.closeHamburger();

		}
		setTimeout( () => {

			this.activateClicksOnMegamenu();

		}, 50 );

	};

	/**
	 * activateClicksOnMegamenu
	 *
	 * @return {void}
	 */
	activateClicksOnMegamenu() {

		this.menuItems.forEach( ( item ) => {

			this.toggleDisplay( this.block, item );

		} );

	}

	/**
	 * resetFocus
	 *
	 * @return {void}
	 */
	resetFocus = () => {

		this.removeClassFromAll( this.menuItemsAllMenuname, "js-focus" );

		if ( this.block.querySelectorAll( ".js-focus" ) ) {

			this.removeClassFromAll(
				this.block.querySelectorAll( ".js-focus" ),
				"js-focus",
			);

		}

	};

	/**
	 * focusHandler
	 *
	 * @param {object} e
	 */
	focusHandler = ( e ) => {

		this.resetFocus();

		if ( e.target.parentNode.className === "b-megamenu-tab-item__heading" ) {

			if ( e.target.closest( "div.b-megamenu-tab-item__content" ) ) {

				this.addClassToEl(
					e.target.closest( "div.b-megamenu-tab-item__content" ),
					"js-focus",
				);

			}

		} else {

			this.addClassToEl( e.target.parentNode, "js-focus" );

		}
		if ( this.hasClass( e.target.parentNode.parentNode, "is-dropdown" ) ) {

			if ( this.hasClass( this.block, "js-megamenu--close" ) ) {

				this.openDropdown( e.target.parentNode.parentNode );
				this.openMegamenu( this.block );

			}

		}

	};

	/**
	 * Activate focus on the given wrapper
	 * @return {void}
	 */
	activateFocusAndClicksOnMegamenu() {

		this.menuItemsAll.forEach( ( item ) => {

			this.toggleDisplay( this.block, item );

		} );

	}

	/**
	 * handleMediaQueryChange
	 *
	 * @param {object} e
	 */
	handleMediaQueryChange = ( e ) => {

		const megamenuWrapper = this.block.querySelector( ".b-megamenu__wrapper" );

		if ( e.matches ) {

			if ( megamenuWrapper && megamenuWrapper.style.display === "block" ) {

				megamenuWrapper.style.display = "";

			}

			this.activateFocusAndClicksOnMegamenu();
			// this.activateClicksOnMegamenu( );
			this.removeClassFromEl( this.block, "js-megamenu--mobile" );
			this.closeHamburger();

		} else {

			megamenuWrapper.style.display = "block";

			this.deactivateMegamenu();
			this.activateMobileMegamenu();
			this.addClassToEl( this.block, "js-megamenu--mobile" );
			this.reloadPageIfCommingFromBackButton();

		}

	};

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addEvents() {

		this.hamburgerMenu.checked = false;
		this.hamburgerMenu.addEventListener(
			"click",
			this.hamburgerClickedHandler,
		);

		this.mediaQuery.addEventListener( "change", this.handleMediaQueryChange );
		this.handleMediaQueryChange( this.mediaQuery );

	}

}

/**
 * MegamenuLogo Class
 */
class MegamenuLogo extends Megamenu {

	/**
	 * Constructor
	 *
	 * @param {element} megamenuWrapper
	 * @return {void}
	 */
	constructor( megamenuWrapper ) {

		super( megamenuWrapper );

		this.visibleWrapper = this.block.querySelector(
			".b-megamenu__bg-wrapper",
		);
		this.siteLogo = this.megamenuWrapper.querySelector(
			".wp-block-site-logo",
		);

		setTimeout( () => {

			this.addLogoEvents();

		}, 10 );

	}

	/**
	 * Has site logo
	 *
	 * @return {bool}
	 */
	hasLogo() {

		return this.siteLogo ? true : false;

	}

	/**
	 * Move out logo from the default wrapper
	 *
	 */
	moveOutLogo() {

		if ( this.hasLogo() ) {

			this.visibleWrapper.appendChild( this.siteLogo );

		}

	}

	/**
	 * Move logo to the default wrapper
	 *
	 */
	moveLogoToBegin() {

		if ( this.hasLogo() ) {

			const movedLogo = this.visibleWrapper.querySelector(
				".wp-block-site-logo",
			);

			if ( movedLogo ) {

				this.megamenuWrapper.prepend( movedLogo );

			}

		}

	}

	/**
	 * handleMediaQueryChangeLogo
	 *
	 * @param {object} e
	 */
	handleMediaQueryChangeLogo = ( e ) => {

		if ( e.matches ) {

			this.moveLogoToBegin();

		} else {

			this.moveOutLogo();

		}

	};

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addLogoEvents() {

		this.mediaQuery.addEventListener(
			"change",
			this.handleMediaQueryChangeLogo,
		);
		this.handleMediaQueryChangeLogo( this.mediaQuery );

	}

}

/**
 * MegamenuSearch Class
 */
class MegamenuSearch extends MegamenuLogo {

	/**
	 * Constructor
	 *
	 * @param {element} visibleWrapper
	 * @return {void}
	 */
	constructor( visibleWrapper ) {

		super( visibleWrapper );

		this.extrasInnerBlocks = this.block.querySelector(
			".b-megamenu-extras__inner-blocks",
		);
		if ( !this.extrasInnerBlocks ) {

			return;

		}

		this.search =
			this.extrasInnerBlocks.querySelector( ".b-megamenu-search" );

		setTimeout( () => {

			this.addSearchEvents();

		}, 100 );

	}

	/**
	 * Has Search
	 *
	 * @return {bool}
	 */
	hasSearch() {

		return this.search ? true : false;

	}

	/**
	 * Move out logo from the default wrapper
	 *
	 */
	moveOutSearch() {

		if ( this.hasSearch() ) {

			this.visibleWrapper.appendChild( this.search );
			this.addClassToEl( this.search, "js-search-movedout" );

		}

	}

	/**
	 * Move search to the default wrapper
	 *
	 */
	moveSearchToBegin() {

		if ( this.hasSearch() ) {

			this.extrasInnerBlocks.appendChild( this.search );
			this.removeClassFromEl( this.search, "js-search-movedout" );

		}

	}

	/**
	 * handleMediaQueryChangeSearch
	 *
	 * @param {object} e
	 */
	handleMediaQueryChangeSearch = ( e ) => {

		if ( e.matches ) {

			this.moveSearchToBegin();

		} else {

			this.moveOutSearch();

		}

	};

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addSearchEvents() {

		this.handleMediaQueryChangeSearch( this.mediaQuery );
		this.mediaQuery.addEventListener(
			"change",
			this.handleMediaQueryChangeSearch,
		);

	}

}

/**
 * MegamenuButtons Class
 */
class MegamenuButtons extends MegamenuSearch {

	/**
	 * Constructor
	 *
	 * @param {element} visibleWrapper
	 * @param {element} extrasInnerBlocks
	 * @return {void}
	 */
	constructor( visibleWrapper, extrasInnerBlocks ) {

		super( visibleWrapper, extrasInnerBlocks );

		this.phoneCloned = "";
		this.buttons =
			this.extrasInnerBlocks.querySelector( ".wp-block-buttons" );
		this.phone = this.extrasInnerBlocks.querySelector( ".b-megamenu-phone" );
		this.buttonAll =
			this.extrasInnerBlocks.querySelectorAll( ".wp-block-button" );
		setTimeout( () => {

			this.addButtonsEvents();

		}, 100 );

	}

	/**
	 * Has buttons
	 *
	 * @return {bool}
	 */
	hasButtons() {

		return this.buttons ? true : false;

	}

	/**
	 * Has phone
	 *
	 * @return {bool}
	 */
	hasPhone() {

		return this.phone ? true : false;

	}

	/**
	 * Move out logo from the default wrapper
	 *
	 */
	moveOutButtons() {

		if ( this.hasButtons() ) {

			this.visibleWrapper.appendChild( this.buttons );
			this.addClassToEl( this.buttons, "js-buttons-movedout" );

		}

	}

	/**
	 * Move out phone block from the default wrapper
	 *
	 */
	moveOutPhone() {

		if ( this.hasPhone() ) {

			this.phoneCloned = this.phone.cloneNode( true );
			this.phoneCloned.classList.add( "js-cloned-phone" );
			this.visibleWrapper.appendChild( this.phoneCloned );

		}

	}

	/**
	 * Move logo to the default wrapper
	 *
	 */
	moveButtonsToBegin() {

		if ( this.hasButtons() ) {

			this.extrasInnerBlocks.appendChild( this.buttons );
			this.removeClassFromEl( this.buttons, "js-buttons-movedout" );

		}

	}

	/**
	 * Move phone block to the default wrapper
	 *
	 */
	movePhoneToBegin() {

		if ( this.hasPhone() ) {

			if ( this.phoneCloned.parentNode ) {

				this.phoneCloned.parentNode.removeChild( this.phoneCloned );

			}

		}

	}

	/**
	 * Change changeFontSizeClass for mobile
	 * @param  {string} fromClass
	 * @param  {string} toClass
	 */
	changeFontSizeClass( fromClass, toClass ) {

		if ( this.hasButtons() ) {

			this.buttonAll.forEach( ( button ) => {

				if ( this.hasClass( button, fromClass ) ) {

					button.classList.remove( fromClass );
					button.classList.add( toClass );

				}

			} );

		}

	}

	/**
	 * Change changeButtonClass for mobile
	 * @param  {string} fromClass
	 * @param  {string} toClass
	 */
	changeButtonClass( fromClass, toClass ) {

		if ( this.hasButtons() ) {

			this.buttonAll.forEach( ( button ) => {

				if ( this.hasClass( button, fromClass ) ) {

					button.classList.remove( fromClass );
					button.classList.add( toClass );

				}

			} );

		}

	}

	/**
	 * handleMediaQueryChangeButtons
	 *
	 * @param {object} e
	 */
	handleMediaQueryChangeButtons = ( e ) => {

		if ( e.matches ) {

			this.moveOutButtons();

		} else {

			this.moveButtonsToBegin();

		}

	};

	/**
	 * handleMediaQuerySmallMobileChangeButtons
	 *
	 * @param {object} e
	 */
	handleMediaQuerySmallMobileChangeButtons = ( e ) => {

		if ( e.matches ) {

			//max-width: 639px

			this.changeFontSizeClass( "has-14-font-size", "has-16-font-size" );
			this.changeButtonClass(
				"is-style-transparent",
				"is-style-filled-peach",
			);
			this.changeButtonClass( "is-style-link-white", "is-style-link" );
			this.moveButtonsToBegin();

		} else {

			this.changeFontSizeClass( "has-16-font-size", "has-14-font-size" );
			this.changeButtonClass(
				"is-style-filled-peach",
				"is-style-transparent",
			);
			this.changeButtonClass( "is-style-link", "is-style-link-white" );
			// this.moveOutButtons()

		}

	};

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addButtonsEvents() {

		this.mediaQueryBetween.addEventListener(
			"change",
			this.handleMediaQueryChangeButtons,
		);

		this.mediaQuerySmallMobile.addEventListener(
			"change",
			this.handleMediaQuerySmallMobileChangeButtons,
		);

		this.handleMediaQuerySmallMobileChangeButtons(
			this.mediaQuerySmallMobile,
		);

		this.handleMediaQueryChangeButtons( this.mediaQueryBetween );

	}

}

document.querySelectorAll( ".b-megamenu" ).forEach( ( block ) => {

	// new Megamenu( block );
	// new MegamenuLogo( block );
	// new MegamenuSearch( block );
	new MegamenuButtons( block );

} );
